// 非空間データテーブルのストア（「データ」タブの状態の単一の真実）。
//
// 役割: アップロードした位置情報なし CSV を DuckDB テーブルとして取り込んだ際の
//       メタ（テーブル名・列・行数・サンプル）をメモリ保持し、変更を購読者（React）へ通知する。
// 関係: React からは useSyncExternalStore で購読する（subscribe / getSnapshot）。
//       layer-store.js の簡易版（色・表示可否・bounds・undo/redo を持たない）。地図には載らず、
//       エージェントには system プロンプト末尾へ列挙されて JOIN 対象として見える。
//
// データテーブルオブジェクトの形:
//   { tableId, displayName, columns: [{ name, type }], rowCount, sample, createdAt }

export class DataStore {
  #tables = [] // 不変配列（更新のたび新しい参照に差し替え）
  #listeners = new Set()

  // 購読登録。返り値は解除関数（useSyncExternalStore 用）。
  subscribe = (listener) => {
    this.#listeners.add(listener)
    return () => this.#listeners.delete(listener)
  }

  // 現在のデータテーブル配列（同一参照を返し再描画を最小化）。
  getSnapshot = () => this.#tables

  #commit(next) {
    this.#tables = next
    for (const listener of this.#listeners) listener()
  }

  add(table) {
    this.#commit([...this.#tables, table])
  }

  remove(tableId) {
    const table = this.#tables.find((t) => t.tableId === tableId)
    if (!table) return null
    this.#commit(this.#tables.filter((t) => t.tableId !== tableId))
    return table
  }

  get(tableId) {
    return this.#tables.find((t) => t.tableId === tableId) ?? null
  }

  clear() {
    this.#commit([])
  }
}
